import { Button, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function CreateSettingsFirst() {
  const navigate = useNavigate();

  const goToSettings = () => {
    navigate("/dashboard/settings/banking");
  };
  return (
    <div style={{ marginBottom: 50 }}>
      <Typography style={{ margin: 50 }} align="center" variant="h3">
        Noch keine Banking-Einstellungen gefunden.
      </Typography>
      <hr />
      <Typography style={{ margin: 100 }} align="center" variant="h4">
        Bitte richten Sie zuerst Ihre SEPA-Lastschrift-Daten ein, damit
        Vorlagen erstellt werden können.
      </Typography>
      <Grid justify="center" container>
        <Grid alignItems="center" item lg={6} xs={12}>
          <Button
            style={{ fontSize: "150%", minHeight: "60px" }}
            fullWidth
            variant="contained"
            color="primary"
            onClick={goToSettings}
          >
            Einstellungen öffnen
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
